import React, { Component } from "react"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
})


class OrganTherapyContractConditions extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  conditionState: this.props.condition,
                  selectedInstalmentMode: {
                        value: this.props.condition.organ_therapycontract_conditions_covarage_id,
                        label: this.props.condition.organ_therapycontract_conditions_covarage_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  optionInstalmentMode: [],
            }
      }
      componentDidMount() {
            this.getoptionInstalmentMode()
      }
      getoptionInstalmentMode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].organ_therapycontract_conditions_covarage_id, label: arr.data[k].organ_therapycontract_conditions_covarage_name })
                              }
                              self.setState({ optionInstalmentMode: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_organ_therapycontract_conditions_covarage")
            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleInstalmentMode = (selectedInstalmentMode) => {
            var temparray = this.state.conditionState
            temparray.organ_therapycontract_conditions_covarage_id = selectedInstalmentMode.value
            this.setState({ selectedInstalmentMode: selectedInstalmentMode, conditionState: temparray })
      }


      handleChangeConditionsAmaount = (event) => {
            var temparray = this.state.conditionState
            temparray.organ_therapycontract_conditions_amount = event
            this.setState({ conditionState: temparray })
      }

      handleChangeConditionsDesc = (event) => {
            var temparray = this.state.conditionState
            temparray.organ_therapycontract_conditions_desc = event.target.value
            this.setState({ conditionState: temparray })
      }

      saveNewInstalmentCondition = () => {
            const { conditionState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_organ_therapycontract_conditions")
            fd.append("organ_therapycontract_conditions_id", conditionState.organ_therapycontract_conditions_id)
            fd.append("organ_therapycontract_conditions_amount", conditionState.organ_therapycontract_conditions_amount)
            fd.append("organ_therapycontract_conditions_desc", conditionState.organ_therapycontract_conditions_desc)
            fd.append("organ_therapycontract_conditions_tc_c_covarage_id", conditionState.organ_therapycontract_conditions_covarage_id)

            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { conditionState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_organ_therapycontract_conditions")
            fd.append("organ_therapycontract_conditions_id", conditionState.organ_therapycontract_conditions_id)

            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const {
                  optionInstalmentMode,
                  snackMode,
                  snackstr,
                  showSnack,
                  visible,
                  selectedInstalmentMode,
                  conditionState,
            } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={12} sm={5}>
                                    <div>
                                          <label className="on"> پوشش -گروه بیماری</label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"پوشش -گروه بیماری"}
                                                value={selectedInstalmentMode}
                                                onChange={this.handleInstalmentMode}
                                                options={optionInstalmentMode}
                                          />
                                    </div>
                              </Grid>



                              <Grid item item xs={3} sm={2}>
                                    <FloatingLabelInput
                                          placeholder="حداکثر تعهدات"
                                          type={'currency'}
                                          handleInputt={this.handleChangeConditionsAmaount}
                                          value={conditionState.organ_therapycontract_conditions_amount}
                                    />
                              </Grid>
                              <Grid item item xs={5} sm={3}>
                                    <FloatingLabelInput
                                          placeholder="توضیحات"
                                          handleInputt={this.handleChangeConditionsDesc}
                                          value={conditionState.organ_therapycontract_conditions_desc}
                                    />
                              </Grid>

                              <Grid item item xs={4} sm={2}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab style={{ background: "#44b700" }} aria-label="edit" onClick={this.saveNewInstalmentCondition}>
                                                <EditIcon />
                                          </Fab>

                                          <Fab color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default OrganTherapyContractConditions
